import {hpTheme} from '@hconnect/uikit/src/lib2'
import {Box} from '@mui/system'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {STOCK_CARD_WIDGET_NAMESPACE} from '../consts'

import {Legend, LegendItem} from './Legend'

const {palette} = hpTheme

export const StockDevelopmentChartLegend = () => {
  const {t} = useTranslation(STOCK_CARD_WIDGET_NAMESPACE)
  return (
    <Legend testId="stock_development_chart_legend">
      <LegendItem label={t('chartLegend.minimumStock')}>
        <Box
          component="svg"
          sx={{
            width: ({spacing}) => spacing(5),
            height: '3px'
          }}
        >
          <Box
            component="line"
            x1={0}
            x2={30}
            y1={1}
            y2={1}
            sx={{
              strokeWidth: 1,
              strokeDasharray: '4,4',
              shapeRendering: 'crispEdges',
              opacity: 1,
              stroke: palette.error.light
            }}
          />
        </Box>
      </LegendItem>
      <LegendItem label={t('chartLegend.capacityDeadStock')}>
        <Box
          component="svg"
          sx={{
            width: ({spacing}) => spacing(5),
            height: '3px'
          }}
        >
          <Box
            component="line"
            x1={0}
            x2={30}
            y1={1}
            y2={1}
            sx={{
              shapeRendering: 'crispEdges',
              strokeWidth: 1,
              opacity: 1,
              stroke: palette.error.light
            }}
          />
        </Box>
      </LegendItem>
    </Legend>
  )
}
